define('orderStatusCreateEditLayoutView',[
  'module',
  'marionette',
  'backbone',
  'jquery',
  'dialogFormView',
  'template!orderStatusCreateEditLayoutTpl',
  'savingBehavior',
  'bootbox',
  'underscore',
  'app',
  'settings',
  'autocompleteView'
], function(
  module,
  Marionette,
  Backbone,
  $,
  DialogFormView,
  createEditLayoutTpl,
  SavingBehavior,
  bootbox,
  _,
  App,
  Settings,
  AutocompleteView
) {
  'use strict';

  var CreateEditLayoutView = DialogFormView.extend({
    template: createEditLayoutTpl,

    ui: {
      input: '.js-info-input',
      cancel: '.js-cancel',
      confirm: '.js-confirm',
      displayInKanban: '#displayInKanban',
      validatedStatus: '#validatedStatus',
      commentStatus: '#commentStatus',
      assignUserToOrder: '#assignUserToOrder',
      unAssignUsers: '#unAssignUsers',
      orderDue: '#orderDue',
      salesActionRequired: '#salesActionRequired',
      supportActionRequired: '#supportActionRequired',
      checkAfterHours: '#checkAfterHours',
      endsLateCheck: '#endsLateCheck'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input' : 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm',
      'change @ui.displayInKanban' : 'onChangeDisplayInKanban',
      'change @ui.validatedStatus' : 'onChangeValidatedStatus',
      'change @ui.commentStatus' : 'onChangeCommentStatus',
      'change @ui.assignUserToOrder' : 'onChangeAssignUserToOrder',
      'change @ui.unAssignUsers' : 'onChangeUnAssignUsers',
      'change @ui.orderDue' : 'onChangeOrderDue',
      'change @ui.salesActionRequired' : 'onChangeSalesActionRequired',
      'change @ui.supportActionRequired' : 'onChangeSupportActionRequired',
      'change @ui.checkAfterHours' : 'onChangeCheckAfterHours',
      'change @ui.endsLateCheck' : 'onChangeEndsLateCheck'
    },

    regions: {
      parentStatus: '.js-select-ref-parent-status'
    },

    className: 'orderstatus-create-edit',

    behaviors: {
      Saving: {
        behaviorClass: SavingBehavior
      }
    },

    modelEvents: {
      sync: 'onSave',
      error: 'onSaveError'
    },

    fieldsToValidate: [
      {name: 'name', type: 'required'},
      {name: 'code', type: 'required'}
    ],

    initialize: function(options) {
      this.model = options.orderStatusModel.clone();
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.newItem = this.options.newItem;
      return templateData;
    },

    onShow: function() {
      var displayInKanban = this.model.get('displayInKanban') || false;
      this.ui.displayInKanban.prop('checked', displayInKanban);

      var commentStatus = this.model.get('commentStatus') || false;
      this.ui.commentStatus.prop('checked', commentStatus);

      var validatedStatus = this.model.get('validatedStatus') || false;
      this.ui.validatedStatus.prop('checked', validatedStatus);

      var assignUserToOrder = this.model.get('assignUserToOrder') || false;
      this.ui.assignUserToOrder.prop('checked', assignUserToOrder);

      var unAssignUsers = this.model.get('unAssignUsers') || false;
      this.ui.unAssignUsers.prop('checked', unAssignUsers);

      var orderDue = this.model.get('orderDue') || false;
      this.ui.orderDue.prop('checked', orderDue);

      var salesActionRequired = this.model.get('salesActionRequired') || false;
      this.ui.salesActionRequired.prop('checked', salesActionRequired);

      var supportActionRequired = this.model.get('supportActionRequired') || false;
      this.ui.supportActionRequired.prop('checked', supportActionRequired);

      var checkAfterHours = this.model.get('checkAfterHours');
      this.ui.checkAfterHours.val(checkAfterHours ? checkAfterHours : '');

      var endsLateCheck = this.model.get('endsLateCheck') || false;
      this.ui.endsLateCheck.prop('checked', endsLateCheck);

      var parentStatusView = new AutocompleteView(
        this.getAutocompleteOptions()
      );
      this.getRegion('parentStatus').show(parentStatusView);

      $.material.init();
    },

    getAutocompleteOptions: function() {
      return {
        type: 'remote',
        alwaysOpen: true,
        remote: Settings.url('compuzz2', 'v2/caccounts/commandStatus', {
          tag: this.model.get('tag')
        }),
        valueKey: 'code',
        apiKey: 'code',
        placeholder: _.i18n('selectparent.placeholder'),
        value: null,
        name: 'code',
        onPressKey: true,
        lazyLoad: true,
        keys: {
          query: 'search',
          limit: 'pageSize'
        },
        callback: _.bind(this.onSelect, this)
      };
    },

    onSelect: function(property, model) {
      this.model.set('refParentStatus', model);
      this.triggerMethod('enable:cancel:confirm');
    },

    onConfirm: function() {
      if(this.validate(this.fieldsToValidate)) {
        this.model.save();
      }
    },

    onChangeDisplayInKanban: function() {
      this.model.set('displayInKanban',this.ui.displayInKanban.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    },

    onChangeValidatedStatus: function() {
      this.model.set('validatedStatus',this.ui.validatedStatus.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    },

    onChangeCommentStatus: function() {
      this.model.set('commentStatus',this.ui.commentStatus.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    },

    onChangeAssignUserToOrder: function() {
        this.model.set('assignUserToOrder',this.ui.assignUserToOrder.is(':checked'));
        this.triggerMethod('enable:cancel:confirm');
    },

    onChangeUnAssignUsers: function() {
        this.model.set('unAssignUsers',this.ui.unAssignUsers.is(':checked'));
        this.triggerMethod('enable:cancel:confirm');
    },

    onChangeOrderDue: function() {
        this.model.set('orderDue',this.ui.orderDue.is(':checked'));
        this.triggerMethod('enable:cancel:confirm');
    },

    onChangeSalesActionRequired: function() {
        this.model.set('salesActionRequired',this.ui.salesActionRequired.is(':checked'));
        this.triggerMethod('enable:cancel:confirm');
    },

    // Hours an order may sit in this status before it needs a check (support
    // worklist + clock on the board). Empty or 0 = never.
    onChangeCheckAfterHours: function() {
        var hours = parseInt(this.ui.checkAfterHours.val(), 10);
        this.model.set('checkAfterHours', hours > 0 ? hours : null);
        this.triggerMethod('enable:cancel:confirm');
    },

    // From this status on (and every status after it on the board), an order
    // is delivered even without a tracking: never "late" on the support worklist.
    onChangeEndsLateCheck: function() {
        this.model.set('endsLateCheck', this.ui.endsLateCheck.is(':checked'));
        this.triggerMethod('enable:cancel:confirm');
    },

    onChangeSupportActionRequired: function() {
        this.model.set('supportActionRequired',this.ui.supportActionRequired.is(':checked'));
        this.triggerMethod('enable:cancel:confirm');
    },


    onSave: function(model) {
      var modelJSON = model.toJSON();

      this.options.orderStatusModel.set(modelJSON);
      this.triggerMethod('saved');
      App.trigger('orderstatus:header:rerender', modelJSON);
      App.navigate('caccount/' + Settings.get('currentCAccount').secId, {trigger: false});
      if(model.get('tag') !== null && model.get('tag') === 'offer') {
        App.navigate('caccount/' + Settings.get('currentCAccount').secId + '/offerstatus', {trigger: true});
      } else {
        App.navigate('caccount/' + Settings.get('currentCAccount').secId + '/orderstatus', {trigger: true});
      }
      this.hide();
    },

    onSaveError: function(model, response) {
      if(response.status === 409) {
        this.onDuplicateCode();
        this.triggerMethod('hide:label');
      }
    },

    onDuplicateCode: function() {
      this.ui.endUserIdInput.popover('show');
      this.ui.endUserIdInput.addClass('invalid');
      this.ui.endUserIdInput.closest('div[data-field-name=endUserId]').addClass('has-error');
    }

  });

  module.exports = CreateEditLayoutView;
});

